import {
    FETCH_HEALTHCARE_PROFILE,
    UPDATE_HEALTHCARE_PROFILE,
    START_LOADING,
    END_LOADING,
    FETCH_HEALTHCARE_PROFILE_ERROR,
    FETCH_HEALTHCARE_VENDORS,
    DELETE_HEALTHCARE_VENDOR
} from '../constants/actionTypes';

const initialState = {
    profile: null,
    healthcareVendors: [],
    loading: false,
    error: null,
};

export const healthcareProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, loading: true, error: null };
        case END_LOADING:
            return { ...state, loading: false };
        case FETCH_HEALTHCARE_PROFILE:
            return { ...state, profile: action.payload };
        case FETCH_HEALTHCARE_VENDORS:
            return { ...state, healthcareVendors: action.payload };
        case UPDATE_HEALTHCARE_PROFILE:
            return {
                ...state,
                profile: action.payload,
                healthcareVendors: state.healthcareVendors.map((item) =>
                    item._id === action.payload._id ? action.payload : item
                ),
            };
        case DELETE_HEALTHCARE_VENDOR:
            return {
                ...state,
                healthcareVendors: state.healthcareVendors.filter((item) => item._id !== action.payload),
            };
        case FETCH_HEALTHCARE_PROFILE_ERROR:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

